import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ReactComponent as CloseIcon } from "../../assets/Icons/cross.svg";
import { unsubscribe } from "../../Screens/Accounts/AccountSettings/service";
import Translate, { useTranslateText } from "../Multilanguage/Translate";
const CancelSubscriptionModal = ({ setCancelSubModal, subId, userSubscriptionId, fetchAccountDetails, pause_status, setPauseSubModal, newUi = false }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const translateText = useTranslateText();
  const [cancelSubError, setCancelSubError] = useState({ error: false, message: null })
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  const [needPause, setNeedPause] = useState([50148, 50124].includes(appInfo?.projectDetails?.projectConfig?.pubid));
  const cancelSubscriptionHandler = (status) => {
    if (status === "yes") {
      cancelSubscription()
    } else {
      setCancelSubModal(false)
    }
  }

  const renderContentWithBreaks = (textKey) => {
    const content = translateText(textKey);
    return content?.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < content?.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const cancelSubscription = async () => {
    try {

      const cancelSubscriptionResponse = await unsubscribe(appInfo, subId, userSubscriptionId);
      if (cancelSubscriptionResponse?.status === 200) {
        toast.success(<Translate textKey={'subscription_cancelled'} />, {
          position: "bottom-center",
        });
        setCancelSubModal(false)
        fetchAccountDetails(true)
      } else if (cancelSubscriptionResponse?.status === 201) {
        setCancelSubError({ error: true, message: cancelSubscriptionResponse?.data?.message })
      }
      else{
         toast.error(cancelSubscriptionResponse?.message, {
            position: "bottom-center",
          });
      }
    } catch (err) {
      toast.error(err.message, {
        position: "bottom-center",
      });

    }
  }
  if (newUi) {
    return (
      <div className="cancelSub newUi">
        <div className="overlayModal"></div>
        <div className="contents">
          <button className="closePauseContainer" onClick={() => setCancelSubModal(false)} aria-label="close">
            <CloseIcon />
          </button>

          {!cancelSubError.error ? (
            <>
              <h1><Translate textKey={'cancel_subscription_alert'} /></h1>

              <div className="buttons">
                <div className="buttonContainer button-danger" onClick={() => cancelSubscriptionHandler("yes")}>
                  <div className="background"></div>
                  <button><Translate textKey={'cancel_membership'} /></button>
                </div>
                <div className="buttonContainer button-primary" onClick={() => cancelSubscriptionHandler("no")}>
                  <div className="background"></div>
                  <button><Translate textKey={'keep_plan'} /></button>
                </div>
              </div>
            </>
          ) : (
            <>
              <h1 className="error">{renderContentWithBreaks(cancelSubError?.message)}</h1>
              <div className="buttons">
                <div className="buttonContainer button-primary" onClick={() => cancelSubscriptionHandler("no")}>
                  <div className="background"></div>
                  <button><Translate textKey={'ok'} /></button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="cancelSub">

      <div className="overlayModal"></div>


      <div className="contents">
        <div className="closePauseContainer" onClick={() => setCancelSubModal(false)}>
          <CloseIcon />
        </div>

      {needPause ? (
          <>
            <h1>{renderContentWithBreaks('pause_subscription_message')}</h1>
            <div className="buttons">
              <div
                className="buttonContainer"
                onClick={() => {
                  setPauseSubModal(true);
                  setCancelSubModal(false);
                }}
              >
                <div className="background"></div>
                <button><Translate textKey={'yes'} /></button>
              </div>
              <div
                className="buttonContainer"
                onClick={() => setNeedPause(false)}
              >
                <div className="background"></div>
                <button><Translate textKey={'no'} /></button>
              </div>
            </div>
          </>
        ) : (
          <>
            {
              !cancelSubError.error ? (
                <h1>
                  <Translate textKey={'cancel_subscription_alert'} />
                </h1>
              ) : (
                <h1>{renderContentWithBreaks(cancelSubError?.message)}</h1>
              )
            }

            <div className="buttons">
              {
                !cancelSubError.error ? (
                  <>
                    <div className="buttonContainer" onClick={() => cancelSubscriptionHandler("yes")}>
                      <div className="background"></div>
                      <button><Translate textKey={'yes'} /></button>
                    </div>
                    <div className="buttonContainer" onClick={() => cancelSubscriptionHandler("no")}>
                      <div className="background"></div>
                      <button><Translate textKey={'no'} /></button>
                    </div>
                  </>
                ) : (
                  <div className="buttonContainer" onClick={() => cancelSubscriptionHandler("no")}>
                    <div className="background"></div>
                    <button><Translate textKey={'ok'} /></button>
                  </div>
                )
              }
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CancelSubscriptionModal;
